import {
    Component,
    ElementRef,
    Input,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    ChangeDetectorRef,
    NgZone,
    AfterViewChecked
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Language } from '../language/language-selector';
import { HttpClient } from '@angular/common/http';
import { NavigationMenuItem, NavigationMenuPosition } from './navigation-menu';
import { HeaderConfig } from '../header/header-config';
import { Observable } from 'rxjs/internal/Observable';
import { NavigationConfig } from './navigation-config';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { GoogleTagManagerService } from '../google-tag-manager/google-tag-manager.service';

@Component({
    selector: 'pw-navigationmodule',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewChecked {
    displaySubNav = false;

    @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

    menuIcon = 'menu';

    @Input() hasLogo = true;

    @Input() colorOfMobileSidenav = ''

    @Input() logoUrl = '';

    @Input() dataManagamentUrl = '';

    @Input() aszfUrl = '';

    @Input() isShoppingCart = true;

    @Input() hasLogin = true;

    @Input() colorOfNavBar = 'primaryColor';

    @Input() isAdmin = false;

    @Input() isSubMenuFullScreen = false;

    @Input() hasMatMenu = true;

    @Input() isRowView?: boolean;

    showLogin = 'BEJELENTKEZÉS / REGISZTRÁCIÓ';

    headerConfig: typeof HeaderConfig = HeaderConfig;

    home = 'navigation.home';

    @ViewChildren('icon') icon!: QueryList<ElementRef>;

    id = '';

    isHamburger = true;

    languages: Language[] = [];

    leftNavigationMenu: NavigationMenuItem[] = [];

    loginMenu = false;

    @Input() logoPosition = '';

    @Input() navigationMenu: NavigationMenuItem[] = [];

    @Input() hasMenuTitle = true;

    rightNavigationMenu: NavigationMenuItem[] = [];

    @ViewChild(MatSidenav)
    sidenav!: MatSidenav;

    whichLogoDisplays = false;

    @Input() nameOfTheSite = '';

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';
    isLoggedIn = false;

    menuState: string = 'closed';

    @ViewChild('menu') menu?: MatMenu;

    showSubmenu = false;

    submenu: NavigationMenuItem[] = [];

    @Input() isSideNav = false;

    subSubMenu: NavigationMenuItem[] = [];

    isMobile = true;

    isCollapsed = true;

    submenuOpened = false;

    subsubMenu: NavigationMenuItem[] = [];

    subsubmenuopened = false;

    idSub = '';

    routerLink = '';

    displaySubSubNav = false;

    @Input() adminHomeUrl = '';


    nameOfLink = 'LINK MEGTEKINTÉSE'

    mobileLogoUrl: string = '';

    chunkedSubMenus: NavigationMenuItem[] = [];

    constructor(
        private _matDialog: MatDialog,
        private _obServer: BreakpointObserver,
        private _http: HttpClient,
        private _navigationConfig: NavigationConfig,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private _router: Router,
        private _loginService: LoginService,
        private _googleTagManagerService: GoogleTagManagerService
    ) { }

    ngAfterViewChecked(): void {
        this.ngZone.runOutsideAngular(() => {
            this.ref.detectChanges();
            setTimeout(() => {
                if (sessionStorage.getItem('token')) {
                    this.isLoggedIn = true;
                } else if (!sessionStorage.getItem('token')) {
                    this.isLoggedIn = false;
                }
            }, 0);
        });
    }

    ngOnInit(): void {
        this.getNavigationMenu(this._navigationConfig.navigationMenuConfigPath).subscribe({
            next: (navigationMenu) => {
                navigationMenu.shift();
                this.navigationMenu = navigationMenu;
                /*this.navigationMenu.forEach((item) => {
                    item.chunkedSubMenus = this.chunkArray(item.staticSubMenus || [], 3);
                });*/
                this.orderNavigationMenus(this.navigationMenu);
                this._obServer.observe(['(max-width: 780px)']).subscribe((screenSize) => {
                    if (screenSize.matches) {
                        this.isMobile = true;
                    } else {
                        this.isMobile = false;
                    }
                    if (sessionStorage.getItem('mobile_logo_url')) {
                        this.mobileLogoUrl = JSON.parse(sessionStorage.getItem('mobile_logo_url') as string);
                    }
                });
            }
        });
        // if(this._navigationConfig.isLogoShrink) {
        // this.shrinkLogoOnScroll();
        // } //TODO it should have a config to switch it on/off
    }
    //it slices the mat-menu submenu into more columns with the given size number(this is the max number of navigationElements in a column)
    chunkArray<T>(arr: T[], size: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    }

    settingUpLinkToGoogleAnalytics(linkUrl: string) {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, linkUrl);
    }

    shrinkLogoOnScroll() {
        window.addEventListener('scroll', () => {
            const windowTop = window.scrollY;
            if (windowTop == 0) {
                this.whichLogoDisplays = false;
            } else {
                this.whichLogoDisplays = true;
            }
        });
    }

    orderNavigationMenus(navigationMenus: NavigationMenuItem[]) {
        navigationMenus.map((menu: NavigationMenuItem) => {
            if (menu.positionOnNavBar === NavigationMenuPosition.right) {
                this.rightNavigationMenu.push(menu);
            } else {
                this.leftNavigationMenu.push(menu);
            }
        });
    }

    mobileViewInit() {
        this._obServer.observe(['(max-width: 800px)']).subscribe((res) => {
            if (res.matches) {
                this.sidenav.mode = 'over';
                void this.sidenav.close();
            } else {
                this.sidenav.mode = 'side';
                void this.sidenav.open();
            }
        });
    }

    clickOnLoginIcon() {
        this.loginMenu = !this.loginMenu;
    }

    displaySubmenu(translationKey: string) {
        // this.id = id;
        // this.displaySubNav = !this.displaySubNav;
        // if (this.displaySubSubNav === true) {
        //     this.displaySubSubNav = false;
        // }
        this.navigationMenu.forEach((navigationElement) => {
            if (navigationElement.translationKey === translationKey) {
                navigationElement.isStaticSubmenuVisible = !navigationElement.isStaticSubmenuVisible;
            }
        })
    }

    displaySubSubmenu(translationKey: string) {
        this.navigationMenu.forEach((navigationElement) => {
            navigationElement.staticSubMenus?.forEach((menu) => {
                if (menu.translationKey === translationKey) {
                    menu.isStaticSubmenuVisible = !menu.isStaticSubmenuVisible;
                }
            })
        })

    }

    changeHamburger() {
        this.isHamburger = !this.isHamburger;
    }

    closeSubmenus() {
        this.navigationMenu.forEach((nav) => {
            nav.isStaticSubmenuVisible = false;
            nav.staticSubMenus?.forEach((sub) => {
                sub.isStaticSubmenuVisible = false;
            })
        })
    }

    getNavigationMenu(url: string): Observable<NavigationMenuItem[]> {
        return this._http.get<NavigationMenuItem[]>(url);
    }

    openLogin() {
        this._loginService.openLogin();
    }

    logOut() {
        sessionStorage.clear();
        this._router.navigateByUrl('/');
    }

    getPersonalData() {
        this._router.navigateByUrl('personaldata');
    }

    getMyOrders() {
        this._router.navigateByUrl('myorders');
    }

    openMenu(hasDynamicSubMenu: boolean) {
        if (hasDynamicSubMenu) {
            this.trigger.openMenu();
        }
    }

    routingMenuItem(navigationItem: NavigationMenuItem) {
        if (navigationItem.id !== null) {
            this._router.navigateByUrl(navigationItem.id!);
        }

    }

    showSubMenu(navigation: NavigationMenuItem) {
        if (navigation.hasDynamicSubMenu) {
            this.submenu = navigation.staticSubMenus as NavigationMenuItem[];
            this.showSubmenu = !this.showSubmenu;
        }
        else {
            this.showSubmenu = false;
            this._router.navigateByUrl(navigation.id!);
        }
    }

    closeSubMenu() {
        this.showSubmenu = false;
    }

    toggleMenu() {
        if (this.isMobile) {
            this.sidenav.toggle();
            this.isCollapsed = false;
        } else {
            this.sidenav.toggle();
            this.isCollapsed = !this.isCollapsed;
        }
    }

    toggleSubMenu() {
        this.submenuOpened = !this.submenuOpened;
        if (this.subsubmenuopened) {
            this.subsubmenuopened = false;
        }
    }

    routeOnClick(navigation: NavigationMenuItem) {
        if (!navigation.hasDynamicSubMenu) {
            this._router.navigateByUrl(navigation.id!);
            if (this.isMobile) {
                this.sidenav.close();
            }
        } else if (navigation.hasDynamicSubMenu) {
            this.submenu = navigation.staticSubMenus!;
            this.routerLink = navigation.id!;
            this.toggleSubMenu();
        }
    }

    routeOnClickk(navigation: NavigationMenuItem) {
        if (!navigation.hasDynamicSubMenu) {
            this._router.navigateByUrl(navigation.id!);
            if (this.isMobile) {
                this.sidenav.close();
            }
        } else if (navigation.hasDynamicSubMenu) {
            this.submenu = navigation.staticSubMenus!;
            this.idSub = navigation.id!;
            this.subsubmenuopened = !this.subsubmenuopened;

        }
    }

    routeSubmenuIfItHasRouterLink(submenu: NavigationMenuItem) {
        if (submenu.id) {
            this._router.navigateByUrl(submenu.id);
        }
    }

}
